import React from "react";
import {
    Button
} from '@rebrandly/styleguide'
const FacebookShareButton = ({ url, buttonProps = {} }) => {
    if (!url) {
        return null;
    }

    const shareUrl = new URL('https://www.facebook.com/sharer/sharer.php');
    shareUrl.searchParams.set('u', url);

    const openShareWindow = () => {
        window.open(
            shareUrl.toString(),
            'facebook-share',
            'width=550,height=400'
        );
    };

    return (
        <Button
            onClick={openShareWindow}
            {...buttonProps}
        >
            {buttonProps.children}
        </Button>
    );
};

export default FacebookShareButton;